export default __webpack_public_path__ + "img/bd76ee17d7223cc872ed09d75592c9c8.svg";